import doc                  from '@widesk-core/decorators/doc';
import AbstractWebsiteModel from './AbstractWebsiteModel';
import ShowModel            from '@models/fondations/ShowModel';

@doc.urnResource('website')
export default class WebsiteModel extends AbstractWebsiteModel {
	@doc.modelUrn(ShowModel) declare show: ShowModel;
}
